import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'Carlos M.',
  city: 'Buenos Aires'
}, {
  name: 'Ana R.',
  city: 'Córdoba'
}, {
  name: 'Roberto S.',
  city: 'Rosario'
}, {
  name: 'Marta L.',
  city: 'Mendoza'
}, {
  name: 'Eduardo P.',
  city: 'La Plata'
}, {
  name: 'Graciela T.',
  city: 'Tucumán'
}, {
  name: 'Hugo D.',
  city: 'Mar del Plata'
}, {
  name: 'Silvia F.',
  city: 'Salta'
}, {
  name: 'Ricardo B.',
  city: 'Santa Fe'
}, {
  name: 'Patricia V.',
  city: 'Neuquén'
}];
function getRandomTime() {
  const mins = Math.floor(Math.random() * 15) + 1;
  return `hace ${mins} min`;
}
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const [timeAgo, setTimeAgo] = useState('hace 3 min');
  useEffect(() => {
    // Show first notification after 8 seconds, then every 15-25 seconds
    const showFirst = setTimeout(() => {
      setTimeAgo(getRandomTime());
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 8000);
    const interval = setInterval(() => {
      setCurrentBuyer(prev => (prev + 1) % buyers.length);
      setTimeAgo(getRandomTime());
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, Math.random() * 10000 + 15000); // 15-25 seconds
    return () => {
      clearTimeout(showFirst);
      clearInterval(interval);
    };
  }, []);
  const buyer = buyers[currentBuyer];
  return <AnimatePresence data-id="element-352">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-20 md:bottom-6 left-4 z-40 bg-white rounded-xl shadow-lg border border-navy/10 p-3 pr-5 flex items-center gap-3 max-w-xs" data-id="element-353">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-354">
            <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-355" />
          </div>
          <div data-id="element-356">
            <p className="text-sm font-semibold text-navy" data-id="element-357">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-xs text-navy/60" data-id="element-358">
              Compró MUSIC PRO KIT · {timeAgo}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}